import type { TaskType } from '@econtractor/types';
import EmptyResult from 'components/others/EmptyResult';
import TaskTableRow from './TaskTableRow';

interface TaskTableBodyProps {
    tasks: TaskType[];
    onOpenTask?: (taskId: number) => void;
}

const TaskTableBody = ({ tasks, onOpenTask }: TaskTableBodyProps) => (
    <tbody>
        {tasks.map((task) => (
            <TaskTableRow key={task.ID} task={task} onOpenTask={onOpenTask} />
        ))}

        {tasks.length === 0 && (
            <tr>
                <td colSpan={6}>
                    <EmptyResult />
                </td>
            </tr>
        )}
    </tbody>
);

export default TaskTableBody;
